module.exports = __webpack_public_path__ + "static/img/product_detail1.9062d3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product_detail1.jpg
// module id = Hq/V
// module chunks = 16